import { render, staticRenderFns } from "./CreateTournamentDialog.vue?vue&type=template&id=454e844a&scoped=true"
import script from "./CreateTournamentDialog.vue?vue&type=script&lang=js"
export * from "./CreateTournamentDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateTournamentDialog.vue?vue&type=style&index=0&id=454e844a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e844a",
  null
  
)

export default component.exports